import 'css-chunksrc/client/pages/projectPage/budgetPage/expensesTable/expense/styles.scss';export default {
  "expense": "_expense_128wa_1",
  "cell": "_cell_128wa_6",
  "rowCell": "_rowCell_128wa_18",
  "bigCell": "_bigCell_128wa_31",
  "mediumCell": "_mediumCell_128wa_35",
  "smallCell": "_smallCell_128wa_39",
  "dateCell": "_dateCell_128wa_44",
  "attachmentsCell": "_attachmentsCell_128wa_48",
  "attachmentsCellText": "_attachmentsCellText_128wa_57",
  "bold": "_bold_128wa_63",
  "icon": "_icon_128wa_67",
  "date": "_date_128wa_44",
  "selectList": "_selectList_128wa_80",
  "dateInput": "_dateInput_128wa_84",
  "calendar": "_calendar_128wa_89"
};